/*
  Keeps the in-button price and stock line in sync with the selected variant.

  Subscribes to Dawn's public `variantChange` event (published by assets/product-info.js)
  and copies the freshly re-rendered button price/stock markup into the live button. This
  mirrors Dawn's own `updateSourceFromDestination` pattern and is only needed for products
  whose variants differ in price; it is harmless otherwise.

  Sold-out / unavailable handling is done in CSS via the button's [disabled] state, so no
  JS is required for those cases.
*/
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html || data.sectionId == null) return;

    ['BuyButtonPrice', 'BuyButtonStock'].forEach(function (idPrefix) {
      // The bundle component owns the total; a variant render contains only one unit.
      var form = document.getElementById('product-form-' + data.sectionId);
      if (idPrefix === 'BuyButtonPrice' && form && form.slvrBundle) return;
      var id = idPrefix + '-' + data.sectionId;
      var source = data.html.getElementById(id);
      var destination = document.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  });
})();
